import { render } from "./SubtaskInbox.vue?vue&type=template&id=a6acbaee"
import script from "./SubtaskInbox.vue?vue&type=script&lang=js"
export * from "./SubtaskInbox.vue?vue&type=script&lang=js"

import "./SubtaskInbox.vue?vue&type=style&index=0&id=a6acbaee&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__